import styled from 'styled-components';
import { Tag as AntTag } from 'antd';
import { gray2, gray4, blue4, blue3 } from '@styles/styled/variables';
import { componentClass } from './constants';

export const Wrapper = styled.div`
  border: 1px solid ${gray4};
  border-radius: 6px;
  padding: 8px;

  :hover {
    border-color: ${blue3};
  }

  &.focus {
    border-color: ${blue3};
  }

  input {
    max-width: 100%;
    border: none;
    outline: none;
  }
`;

export const Options = styled.ul`
  position: absolute;
  background-color: white;
  border: 1px solid ${gray4};
  border-radius: 6px;
  padding: 0;
  font-size: 14px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const Option = styled.li`
  list-style-type: none;
  padding: 8px;

  &.${componentClass}_option:hover,
  &.${componentClass}_option.selected {
    cursor: pointer;
    background-color: ${blue4};
  }
`;

export const OuterWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const Tag = styled(AntTag)`
  &.ant-tag {
    margin-bottom: 2px;
    padding: 2px 6px;

    &.remove {
      background-color: ${blue4};
    }

    .anticon-close {
      font-size: 14px;
    }

    span {
      position: relative;
      top: 4px;
      display: inline-block;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 400px;
    }

    :hover {
      cursor: ${({draggable}) => draggable ? 'grab' : 'default'};;
    }
  }

  &.ghost-tag {
    background-color: ${gray2};
  }
`;
